import { createRouter,createWebHashHistory } from "vue-router";

export const routes = ([
    {
        path:'/twos',
        name:'Roller Configuration',
        component:()=>import('@/views/SetupPage.vue'),//英文的 48.6 带双端页面
    },
    {
        path: '/',
        name: 'Roller Configurations',
        component: () => import('@/views/FivtyPage.vue'),//英文的 50 出线端自由端
    },
    {
        path: '/record',
        name: 'Configuration Record',
        component: () => import('@/views/RecordPage.vue')
    },
])

const router = createRouter({
    history:createWebHashHistory(),
    routes:routes
})

export default router;